import { CustomerDepositScreen } from '../screens/Audit/CustomerDepositScreen';
import { CustomerDepositStatementScreen } from '../screens/Audit/CustomerDepositStatementScreen';
import { SellerContractScreen } from '../screens/Audit/SellerContractScreen';
import { SellerContractPreviewScreen } from '../screens/Audit/SellerContractPreviewScreen';

export const AuditRoutes = [
  { path: '/audit/customer-deposit', exact: true, component: CustomerDepositScreen },
  { path: '/audit/customer-deposit-statement/:customerId?', exact: true, component: CustomerDepositStatementScreen },
  { path: '/audit/seller-contract', exact: true, component: SellerContractScreen },
  { path: '/audit/seller-contract-preview', exact: true, component: SellerContractPreviewScreen },
];
